import { required, minLength } from '@vuelidate/validators';

export const validLabelCharacters = (str = '') => !!str && !str.includes(' ');

export const getSharedFileNameErrorMessage = validation => {
  let errorMessage = '';
  if (!validation.name.$error) {
    errorMessage = '';
  } else if (!validation.name.required) {
    errorMessage = 'REQUIRED_ERROR';
  } else if (!validation.name.minLength) {
    errorMessage = 'LENGTH_ERROR';
  } else if (!validation.name.validLabelCharacters) {
    errorMessage = 'VALID_ERROR';
  }
  return errorMessage;
};

export default {
  name: {
    required,
    minLength: minLength(2),
    validLabelCharacters,
  },
  file: {
    required,
  },
};
